export default {"src":"/_next/static/media/8.76f86eb6.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};